
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoPurInvoiceDtGrid extends Serenity.EntityGrid<PoPurInvoiceDtRow, any> {
        protected getColumnsKey() { return PoPurInvoiceDtColumns.columnsKey; }
        protected getDialogType() { return PoPurInvoiceDtDialog; }
        protected getIdProperty() { return PoPurInvoiceDtRow.idProperty; }
        protected getInsertPermission() { return PoPurInvoiceDtRow.insertPermission; }
        protected getLocalTextPrefix() { return PoPurInvoiceDtRow.localTextPrefix; }
        protected getService() { return PoPurInvoiceDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}